module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_40",
      "title": "[40]"
    }
  })]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "CHAPTER_IV"
    }
  }, [_vm._v("CHAPTER IV."), _c('br', {
    staticClass: "calibre"
  }), _vm._v(" "), _c('span', {
    staticClass: "fs2"
  }, [_vm._v("SUSPICIONS.")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Buffalo Bill and his pards tried to “jump a trail” that afternoon and evening, without success.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The scout talked with Brown, the wounded man in the hospital; but got no additional information.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“The two fellers was so masked,” said Brown, “that I couldn’t tell if they was black, white, or red. The surprise was so complete, anyway, that maybe I wouldn’t have noticed. We wasn’t expectin’ trouble—leastways, I wasn’t; for I allowed the agents would be fooled complete, and would tackle the stage, if they done anything. Then, fu’st thing I knew, there was them masked devils whanging away at us with repeating rifles. Austin was killed; and I got this hole in my side. Your Dutch pard was gamy, and clipped one of the agents. I could swear to that; because, as I drapped, I heard the feller rip out a cuss word, and saw him reel back. But he didn’t fall; so, p’raps the wound didn’t amount to much. One of ’em tried to down the Dutchman; but he got away. That’s about all; except that we lost everything. They even took my hardware and Austin’s, with our cartridge belts. Then they drove the burros away. I had my nose ag’inst the yearth, playin’ dead fer all I was wu’th at that time, so I didn’t see ’em go, but I heard ’em. About the next thing I knew, your friend was bendin’ over me. I got purty weak, and I reckon I had fainted. And that’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_41",
      "title": "[41]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Did you see what sort of men they were, as to size?” the scout asked. “You might have done that when they were getting your weapons.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I was too busy playin’ dead jest then to notice clost,” Brown admitted. “But I did see that one was tall and t’other seemed medium size. It was the small one that was wounded.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Did you notice their voices?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Not in p’tickler.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“You were at Juniper Joe’s wedding?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Well, I reckon.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Then you probably saw the man Juniper Joe shot at?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I did.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Joe claimed the man was Tim Benson, the road agent.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I ain’t fergittin’ that, neither.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Try to recall if one of the road agents resembled that man in any way.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Brown pondered over this.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Well, the littlest one might have been him,” he said; “I should say he was about that size.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Some one on the inside must have informed the agents that you and Austin were going over the mountains with the treasure bags,” said the scout. “You couldn’t give a guess as to who that could be?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I’ve been thinkin’ about that,” Brown confessed. “No, I can’t say who it could have been. My best guess is, that if that little man was Benson he hung round somewhere and overheard the talk when the thing was planned.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It’s a good guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_42",
      "title": "[42]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("In Brown’s wounded and feverish condition the scout had talked long enough; and he took his departure.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“A water haul,” he told himself. “But Brown’s guess that the man called Benson may have got onto the thing by eavesdropping may be the right one. I think I should like, right now, to meet Jackson Dane, detective.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He met him, on his return to his hotel; Dane was by the door of his room, awaiting his appearance.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Hello!” said the little man, cheerily. “I’ve been waiting to have a talk with you confidential.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I’m agreeable to that,” said the scout.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He unlocked the door, and they went into the room together. Closing and locking the door, Buffalo Bill hoisted one of the windows.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“What’s that for?” said Dane.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“The window is to let in a breath of air; the door is locked to keep out possible intruders.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Oh!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It startled you?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Well, as you were unkind enough to suggest that I was a fraud of the first water, when I was here before, I didn’t know but you was getting ready to jump at me, and put up a holler for help to hold me.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Buffalo Bill laughed grimly.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“You are nervous.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Who wouldn’t be, knowing that Juniper Joe is walking the streets with two revolvers, ready to down me the minute he sees me? That’s enough to make any man nervous. Are your pards here?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“They’re close about.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I have been hammering away at this case ever since I saw you last; and have a theory.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_43",
      "title": "[43]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Out with it; if you want to share it with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It’s just this. "), _c('em', {
    staticClass: "calibre5"
  }, [_vm._v("Juniper Joe’s wife is one of the road agents.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“What makes you think so?” Buffalo Bill asked mildly, yet showing interest.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“The thing has come to me by degrees. A while ago I was down in Gopher Gabe’s saloon, just inside the door; I had my hat pulled over my eyes, for I didn’t want to be recognized; and I heard men talking in there, by the bar. I don’t know who they were; but what they said gave me all the information I have about that remarkable hold-up and shooting in Eagle Gap to-day; though I admit that before that I knew something had happened, for I saw your Dutch pard come in with that wounded man on his back.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“What I heard them saying at Gopher Gabe’s,” he went on, “was that the Dutchman reported that one of the agents was a tall man, and the other a small man. Juniper Joe is a tall man; and Mrs. Joe is a small woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“You don’t think that the new Mrs. Joe is a "), _c('em', {
    staticClass: "calibre5"
  }, [_vm._v("man")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I don’t know about that; but probably a woman. Now, inasmuch as Juniper Joe knew all about the plans for sending the stuff over the mountains on burros, what would have been easier than for him and his wife to disguise and go out there and do the hold-up act?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It could have been done by them, in all probability.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Say that Joe had ten thousand dollars of stuff in the express bags, what of it? There was as much as forty thousand more, as I understand it. That forty thousand would be a big haul.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It would.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_44",
      "title": "[44]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“So, there you are, according to my way of thinking.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Why don’t you arrest Joe, then? You say that you are a detective.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The little man flushed slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I suppose I oughtn’t to admit it,” he said; “but, since Joe took that shot at me, I’m afraid of him; if I should go up to his cabin, he would down me, and ask what I had come for afterward. That’s the way I look at it.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“If I should arrest this woman, and find that you are right, what would you expect?” the scout demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“The half of that ten thousand reward "), _c('em', {
    staticClass: "calibre5"
  }, [_vm._v("for the arrest of Tim Benson")]), _vm._v(",” was the unexpected statement.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“What is that?” cried the scout.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I heard, before I came here, that Tim Benson is a woman!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The scout sat pondering this.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Would that be any reason why Juniper Joe should want to shoot you?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“He knows that I am here after Tim Benson!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I see.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“And you’ll see that I’m right, if you arrest Mrs. Joe,” Dane declared, confidently. “That’s what I want you to do; and the sooner the better.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Why your hurry?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It will keep other fellows from being held up and killed by that couple,” he explained suavely.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The scout sat looking at him.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“This gives me a new idea,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I thought it would.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“For one thing”—he still looked at Dane—“I think I ought to arrest "), _c('em', {
    staticClass: "calibre5"
  }, [_vm._v("you")]), _vm._v("; but—hold on, the door is locked, remember!—I am not going to do it—right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_45",
      "title": "[45]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Jackson Dane, who had leaped up with a startled look, dropped nervously back into his chair.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“You’re humorous—at times.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Think so?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It would turn out to be a boomerang, if you did arrest me and it was found then that I am just what I claim to be; the town would sure have the laugh on you. But you do what I say, and you won’t regret it. Go up to that cabin and arrest Mrs. Joe; and don’t delay about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Why the haste?” Buffalo Bill asked again.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Because I have a feeling that she isn’t going to stay long in Blossom Range, and now is your chance to get Tim Benson by doing it.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He stood up and put on his hat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I am ready to go, now,” he said. “You will do as you please, of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I’m pretty sure to.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Well, think it over, anyway. Perhaps you’ll come round to my opinion.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The scout put the key in the lock, and opened the door.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“So, you don’t intend to arrest me?” said Dane, as he passed out into the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Not right now,” the scout told him.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“That’s kind of you, anyhow.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He laughed lightly, and ran for the head of the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Well behind him, yet keeping the little man in sight, Buffalo Bill trailed him through the streets of Blossom Range, observing that Dane had pulled his hat down over his eyes, and turned up the collar of his coat, as if he did not wish to be recognized. But Blossom Range"), _c('a', {
    attrs: {
      "id": "Page_46",
      "title": "[46]"
    }
  }), _vm._v(" was a bustling place, and men were too busy to pay much attention to pedestrians; so that, apparently, Jackson Dane was not given a second look by any one, as he passed along.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The scout’s interest was quickened when Dane turned to the Casino, as the little local theatre was called, and went in by the entrance marked “Private.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Reaching that door, the scout stood listening; then went in, also; but quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("In a room above, as he stood on the stairs, he distinctly heard Jackson Dane talking with the blonde beauty whose name had been given as Vera Bright.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Well, that’s singular!” was his thought. “He is talking with the same girl that Mrs. Juniper Joe had a confab with! I wonder if there is a connection here?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("But he could not understand what Dane and the girl were saying.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He did not want to be seen spying on the stairs of the Casino, and when it seemed he could not get nearer that room without discovery, as people were passing through the upper halls, he retreated to the street.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("But he did not at once go away.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Taking a position on the opposite side of the street, where he fancied he could not be seen, he watched the door marked “Private.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("But though he tarried there two hours, Jackson Dane did not reappear.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Buffalo Bill was a good deal puzzled, when he made his way back to the Eagle House.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“But there’s one thing,” he resolved; “to-night I’ll watch Juniper Joe’s cabin for a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He did not wait until night, however, before visiting"), _c('a', {
    attrs: {
      "id": "Page_47",
      "title": "[47]"
    }
  }), _vm._v(" the place. He made a bold call on Juniper Joe, soon after leaving the Casino.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The door of the cabin was locked, as usual; but when the scout had rapped briskly two or three times, heavy steps were heard, and Juniper Joe cautiously opened the door.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Oh, it’s you!” he said, when he beheld the scout, his manner uneasy.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Yes; can I come in?” Buffalo Bill answered.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Juniper Joe flung the door open, and invited him in.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The big room which had witnessed the “jubilee” was unoccupied, save by Juniper Joe and the scout.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Your wife is not in?” the scout asked.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“She’s downtown somewhar, gittin’ acquainted with the Blossom Range ladies; she allowed, seein’ that she was mightily int’rested in society back East, that it was goin’ to be plum lonely fer her hyer if she didn’t stir up some women to talk to; so she sailed out, and has been workin’ hard at it the better part of the day.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Juniper Joe had discarded his black broadcloth and shiny cady for a miner’s working suit and a soft, clay-stained hat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Been pokin’ about in my mine,” he explained. “Struck another rich pocket, too!” He beamed. “Allow me to show you some o’ the nuggets I got out of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He went into the other room, and brought out some nuggets—a handful of them.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Beauties, ain’t they?” he said, as the scout inspected them. “Struck the pocket this mornin’, soon after I come back frum the express office, an’ have been gopherin’ round it ever sense. If things keeps up this way,"), _c('a', {
    attrs: {
      "id": "Page_48",
      "title": "[48]"
    }
  }), _vm._v(" I’ll have another shipment to make in a week er so; but, by jings, I don’t let the Wells Fargo handle it!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“They fell down pretty badly on that last job.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“’Jever see anything like it! Every bush round Blossom Range seems to be hidin’ an agent, and the town is full o’ thieves. That’s why I allus keep that door locked when I’m out of the house, or at work back in the mine. I was glad to git that stuff into the hands of the express company, fer I expected every night to be knocked on the head before mornin’, so long as I had it in hyer. Thar’s plenty men in this town would kill ye fer a bag o’ gold dust.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I’m afraid that’s right.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I’m shore of it. And sense Tim Benson is round hyer, I ain’t takin’ no chances.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He indicated the two big revolvers under his coat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I keep ’em strapped to me constant,” he confessed. “It will be him er me, if we meet; and I know it.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He put the nuggets away. On coming back, he asked how Brown was getting along.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Knowing that the man he called Benson had gone to the Casino, Buffalo Bill was tempted to tell him of it; which would perhaps send him down there, looking for him. If a duel came of it, there might be some surprising developments.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("But the scout put the temptation aside.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He did not know how much he could believe of what Juniper Joe and Jackson Dane had said. And, if all were true, he did not care to take the responsibility of setting two men to shooting at each other.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I’m still stalled!” he admitted to himself, when he left Juniper Joe’s cabin.")]), _vm._v(" "), _c('hr', {
    staticClass: "chap2"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5aaef08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0007.vue
// module id = 75
// module chunks = 0